import { connect } from 'react-redux'
import { ServicesComponent } from './ServicesComponent'
import type { RootState } from 'shared/store/reducers'
import { injectIntl } from 'react-intl'
import { applyFilters, resetServices } from 'shared/store/store-locator'
import type { Dispatch } from 'redux'

const mapStateToProps = (state: RootState) => {
    const { selectedServices } = state.storeLocatorPageState
    return {
        selectedServices
    }
}

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
    applyFilters: (filters: Array<string>) => dispatch(applyFilters(filters)),
    resetServices: () => dispatch(resetServices())
})
const Services = injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(ServicesComponent)
)

export { Services }
